import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { APP_ROUTES } from '../constants';
import { getSessionItemWithExpiry } from './utility';
import { SESSION_STORAGE_KEY } from '../constant/auth.constant';

interface ProtectedProps {
  allowedPrivileges?: string[];
  children?: React.ReactNode;
}

const Protected: React.FC<ProtectedProps> = ({ allowedPrivileges, children }) => {
  const [privileges] = useState<string[]>(() => {
    try {
      const storedPrivileges = getSessionItemWithExpiry(SESSION_STORAGE_KEY.PRIVILEGES);
      return storedPrivileges ? JSON.parse(storedPrivileges) : [];
    } catch (error) {
      return [];
    }
  });

  const refreshToken = getSessionItemWithExpiry(SESSION_STORAGE_KEY.REFRESH_TOKEN);
  if (!refreshToken) {
    return <Navigate to={APP_ROUTES.LOGIN} replace />;
  }

  const hasRequiredPrivileges = allowedPrivileges?.some((requiredPrivilege) =>
    privileges.includes(requiredPrivilege),
  );

  if (allowedPrivileges && !hasRequiredPrivileges) {
    return <Navigate to={APP_ROUTES.FORBIDDEN} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default Protected;
